import { Autocomplete, LoadingOverlay, Pagination, Paper, Select, SimpleGrid, Space, Container, Stack, Image, Text, Button, Group } from '@mantine/core';
import React, { memo, useContext, useEffect, useState } from 'react';
import { baseUrl } from '../../Constants/constant';
import useFetch from '../../Customhooks/useFetch';
import { authContext } from '../../context/AuthProvider.component';
import LcaReport from './LcaReport.component';
import { IoMdSearch } from 'react-icons/io';
import { IoAdd } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const LcaReportPage = () => {
    const token = localStorage.getItem("token");
    const { setError }: any = useContext(authContext);
    const [search, setSearch] = useState('');
    const [sendsearch, setSendsearch] = useState('');
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(5);
    const [reports, setReports] = useState<any>([]);

    const navigate = useNavigate();

    const { data: datalist, loading: listloading, error: listError, fetchData: gettable } = useFetch({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token,
        },
    });
    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [page, limit]);

    useEffect(() => {
        gettable(`${baseUrl}compute/lca/calculateLca?search=${sendsearch}&page=${page}&limit=${limit}`);
    }, [page, limit, sendsearch]);

    useEffect(() => {
        if (datalist?.data) {
            setReports(datalist?.data);
        }
    }, [datalist]);

    useEffect(() => {
        if (listError) {
            setError(listError?.message)
        }
    }, [listError]);

    const handlechange = (value: any) => {
        setSearch(value);
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            setSendsearch(search);
        }, 500);

        return () => clearTimeout(timeout);
    }, [search]);

    const totalPages = Math.ceil((datalist?.data?.pagination?.totalRecords || 0) / limit);

    return (
        <>
            <LoadingOverlay
                visible={listloading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            {datalist?.data?.data?.length > 0 && <>
                <Autocomplete
                    // label=""
                    value={search}
                    onChange={handlechange}
                    placeholder="Search by Report Name"
                    leftSection={<IoMdSearch />}
                />
                <SimpleGrid cols={{ base: 1, sm: 1, lg: 1 }}>
                    {reports?.data?.map((report: any, index: number) => (
                        <Paper key={index} shadow='lg' p='sm' w='100%'>
                            <LcaReport value={report} reportId={`pdf-report-container-${index}`} />
                            <Space h="xl" />
                            <Space h="xl" />
                        </Paper>
                    ))}
                </SimpleGrid>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                    <Select
                        data={[
                            { value: '5', label: '05 per page' },
                            { value: '10', label: '10 per page' },
                            { value: '20', label: '20 per page' },
                        ]}
                        value={limit.toString()}
                        onChange={(value) => setLimit(Number(value))}
                        style={{ width: '150px' }}
                    />
                    <Pagination total={totalPages} value={page} onChange={setPage} color="#404040" />
                </div>
            </>}
            {datalist?.data?.data?.length == 0 &&
                <>
                    <Container size="md" style={{ minHeight: '70vh' }}>
                        <Stack
                            align="center"
                            justify="center"
                            gap="xl"
                            style={{ minHeight: '70vh' }}
                        >
                            <Image
                                src="4936930.jpg"
                                alt="Empty dashboard"
                                width={200}
                                height={200}
                                fit="contain"
                            />

                            <Stack align="center" gap="sm">
                                <Text size="xl" fw={600} c="dimmed">
                                    No data to display
                                </Text>
                                <Text size="sm" c="dimmed" ta="center" maw={400}>
                                    Create your first report to get started
                                </Text>
                            </Stack>

                            <Group>
                                <Button color='#404040' leftSection={<IoAdd size={16} />} onClick={() => navigate('/newlca')}>
                                    Add Reports
                                </Button>
                            </Group>
                        </Stack>
                    </Container>
                </>}
            <Space h={'xl'} />
        </>
    )
}

export default memo(LcaReportPage);